module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShown),
      expression: "isShown"
    }],
    staticClass: "wechat-overlay"
  }, [_c('section', {
    staticClass: "wechat"
  }, [_c('img', {
    staticClass: "wechat-qr-code",
    attrs: {
      "src": require("@/assets/images/overlays/wechat-qr-code.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("扫一扫"), _c('br'), _vm._v("关注如意官方微信")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87a9b004","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/Overlays/WechatOverlay.vue
// module id = 635
// module chunks = 1